{
  "aiGeneratedAnswer": "AI 생성 답변",
  "allCategories": "전체 카테고리",
  "appliedFiltersToCurrentSearch": "현재 검색에 적용된 필터",
  "apply": "적용",
  "applyFilters": "필터 적용",
  "autocompleteOptionsFound_other": "{{count}}{{label}}개의 자동완성 옵션을 찾았습니다.",
  "autocompleteSuggestion": "자동완성 제안: {{suggestion}}",
  "autocompleteSuggestionsFound_other": "{{count}}개의 자동완성 제안을 찾았습니다.",
  "basedOnYourDevice": " (기기 기준)",
  "basedOnYourInternetAddress": " (인터넷 주소 기준)",
  "categoriesText_other": "다음 카테고리에서 결과가 나타났습니다: <strong>{{query}}</strong>",
  "clearAll": "모두 지우기",
  "clearMinAndMax": "최소값 및 최대값 지우기",
  "clearTheRangeToSelectOptions": "범위를 지워 옵션을 선택하세요.",
  "clearTheSearchBar": "검색창 지우기",
  "conductASearch": "검색 실행",
  "currentLocation": "현재 위치",
  "didYouMean": "다음을 찾으셨나요 <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "자동완성 결과가 있을 때 위/아래 화살표로 탐색하고 Enter 키로 선택하세요.",
  "feedback": "피드백",
  "invalidRange": "잘못된 범위입니다",
  "max": "최대",
  "min": "최소",
  "navigateToTheNextResultsPage": "다음 결과 페이지로 이동",
  "navigateToThePreviousResultsPage": "이전 결과 페이지로 이동",
  "noAutocompleteOptionsFound": "자동완성 옵션이 없습니다.",
  "noAutocompleteSuggestionsFound": "자동완성 제안이 없습니다.",
  "noResultsFoundIn": "{{currentVerticalLabel}}에서 결과를 찾을 수 없습니다.",
  "pagination": "페이지네이션",
  "readMoreAbout": "<a>{{name}}</a>에 대해 더 읽기",
  "recentSearch": "최근 검색: {{query}}",
  "recentSearchesFound_other": "{{count}}개의 최근 검색어가 있습니다.",
  "removeFilter": "「{{displayName}}」필터 제거",
  "resultPreview": "결과 미리보기: {{value}}",
  "resultPreviewsFound_other": "{{count}}개의 미리보기를 찾았습니다.",
  "resultsCountText_other": "{{count}}개 결과",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} / 총 {{resultsCount}}개 결과",
  "searchHere": "여기에 검색…",
  "showLess": "간략히 보기",
  "showMore": "더 보기",
  "showingAllInstead": "{{currentVerticalLabel}} 전체를 표시하고 있습니다.",
  "sources_other": "출처 ({{count}})",
  "submitSearch": "검색",
  "suggestionResultsCount_other": "{{label}} - {{count}}개 결과",
  "thankYouForYourFeedback": "피드백 감사합니다!",
  "thisAnsweredMyQuestion": "질문에 대한 답변이 되었습니다",
  "thisDidNotAnswerMyQuestion": "질문에 대한 답변이 아닙니다",
  "unselectAnOptionToEnterInARange": "범위를 입력하려면 선택을 취소하세요.",
  "updateYourLocation": "위치 업데이트",
  "useCurrentLocation": "현재 위치 사용",
  "useMyLocation": "내 위치 사용",
  "viewAll": "전체 보기",
  "viewDetails": "자세히 보기"
}
